import { getFilteredData, getSortedData } from "../../../List/helper";
export const getFilteredProducts = ({ products, filterKey }) => {
    return getFilteredData({ data: products, filterKey })
}
export const getSortedProducts = ({ vehicles, sort }) => {
    return getSortedData({ data: vehicles, sort })
  }